"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var styles_1 = require("@material-ui/core/styles");
var theme_1 = __importDefault(require("../../../styles/theme"));
var makeStyles_1 = __importDefault(require("../../../util/makeStyles"));
exports.default = (0, makeStyles_1.default)(function () {
    return (0, styles_1.createStyles)({
        buttonRoot: {
            background: 'white',
            borderRadius: 16,
            boxShadow: theme_1.default.shadows.strong,
            height: 32,
            textTransform: 'unset',
            opacity: 0,
            visibility: 'hidden',
            position: 'fixed',
            left: '50%',
            bottom: 14,
            transition: theme_1.default.transitions.easeOutSlow,
            whiteSpace: 'nowrap',
            padding: '4px 16px',
            transform: 'translateY(48px) translateX(-50%)',
            zIndex: theme_1.default.zIndex.actionButton,
            '&:hover': {
                background: 'white',
            },
        },
        buttonHasIcon: {
            paddingLeft: 8,
        },
        buttonVisible: {
            opacity: 1,
            visibility: 'visible',
            transform: 'translateY(0) translateX(-50%)',
        },
    });
});
